export const FIREFLIES = [
  { left: '7%',  bottom: '28%', size: 5,  delay: '0s',    dur: '4s'   },
  { left: '14%', bottom: '42%', size: 7,  delay: '0.7s',  dur: '3.2s' },
  { left: '24%', bottom: '33%', size: 4,  delay: '1.2s',  dur: '5s'   },
  { left: '34%', bottom: '52%', size: 6,  delay: '0.3s',  dur: '3.8s' },
  { left: '44%', bottom: '38%', size: 5,  delay: '2s',    dur: '4.5s' },
  { left: '54%', bottom: '48%', size: 7,  delay: '1.5s',  dur: '3.6s' },
  { left: '64%', bottom: '32%', size: 5,  delay: '0.8s',  dur: '4.2s' },
  { left: '74%', bottom: '58%', size: 4,  delay: '2.3s',  dur: '3s'   },
  { left: '83%', bottom: '43%', size: 6,  delay: '0.5s',  dur: '5.2s' },
  { left: '91%', bottom: '36%', size: 5,  delay: '1.8s',  dur: '3.9s' },
  { left: '29%', bottom: '62%', size: 3,  delay: '3s',    dur: '6s'   },
  { left: '68%', bottom: '68%', size: 4,  delay: '2.5s',  dur: '5.5s' },
];
